import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { EP } from "@core/config";
import { AuthService } from "@core/services/auth";

export const MaintenanceGuard: CanActivateFn = async (route: any, state: any) => {
  const router = inject(Router);
  const service = inject(AuthService);

  // 👇 If not loaded, load it here
  if (service.maintenance() === null) {
    await service.loadStatus(EP.Public); // pass correct EP.Public here
  }

  const isMaintenance = service.maintenance();

  if (isMaintenance && !state.url.includes('maintenance')) {
    return router.createUrlTree(['/maintenance']);
  }

  if (!isMaintenance && state.url.includes('maintenance')) {
    return router.createUrlTree(['/']);
  }

  return true;
};